module.exports = __webpack_public_path__ + "static/media/cny-set-2023-4.3c319811.gif";